import React from 'react';

import './Styles.scss';
import './styles.css';

const En = () => {
  return (
    <div className=" privacy-page ">
      <h2>BASF's Privacy Policy</h2>
      <p>
        BASF is flattered by your visit on our website/app. Thank you for your
        interest in our company.
      </p>
      <br />
      <p>
        We at BASF attach high priority to data protection. This page is
        designed to provide information on how we are following data protection
        regulations, what information we collect while you are browsing our
        website/app, and how this information is collected, used and protected
        by us, in compliance with Law No. 13,709/2018 General Data Protection
        Law (Lei Geral de Proteção de Dados, LGPD). Therefore, the provisions
        contained herein reflect the aspects covered by the Brazilian law.
      </p>
      <br />
      <p>
        First and foremost: your personal data will only be used in the cases
        detailed below, and will not be used in any other cases without your
        express consent.
      </p>
      <p>
        This Data Privacy Policy applies to data collection and processing only
        for the following communication platforms/fronts: email marketing,
        social media (Facebook, LinkedIn and YouTube), mobile device
        application, corporate website, and WhatsApp (receiving content and
        information about the brand).
      </p>
      <br />

      <h2>Data collection</h2>
      <p>
        After user authentication, the application stores the date and time of
        the access, information associated with user's registration.
      </p>
      <br />
      <p>
        In order to use the application, it is necessary to collect the
        following personal data: name, mobile number and e-mail of the users.
        Mobile is required for the app's dual authentication process. E-mail is
        required to send a product quote request and the app stores the order
        history. The connection data between the user and the multiscent device
        is also stored, if the user has one. In the case of possession of the
        equipment, the trial data of each product are also stored.
      </p>
      <br />

      <h2>Personal data collection and processing</h2>
      <p>
        Personal data are only collected when you provide it, for example, when
        registering on our website/app, completing forms or sending e-mails, or
        through product or service orders, inquiries or material requests.
      </p>
      <br />
      <p>
        Your personal data remain with us, our affiliates, and our provider, and
        BASF may share it only with our suppliers/service providers who need
        access to such data to fulfill their obligations to BASF. Such
        suppliers/service providers may then only use your personal data in
        accordance with our instructions and the purposes set out below in this
        Policy, and are contractually bound to comply with applicable legal
        requirements for data protection.
      </p>
      <br />
      <p>
        The personal data we collect will only be used in order to fulfill our
        obligations toward you, and to keep you informed about events, technical
        content/studies, products, services, opinion polls about products and
        services and/or other information from BASF, according to your profile,
        through marketing e-mails. BASF can also use the data collected for the
        development of studies, surveys and internal marketing analysis, carried
        out to improve our actions. Besides that, for the purposes of quality
        assurance, and for legal, security and training issues, we may monitor,
        record and archive calls, chats and other communications.
      </p>
      <br />
      <p>
        The personal data we collect will only be used in order to fulfill our
        obligations to you and keep you informed regarding events, technical
        content/studies, products, services, opinion polls about products and
        services and/or other information from BASF, as per your profile,
        through marketing emails. BASF may also use the data collected for the
        development of studies, researches and internal marketing analyzes
        carried out to improve our actions. Furthermore, for quality assurance
        as well as for legal, security and training reasons, we may monitor,
        record and archive calls, chat conversations and other communications.
      </p>
      <br />
      <p>
        Important: your personal data will only be used for any other purpose
        when you have given your specific consent therefore. You can revoke your
        consent to the use of the your personal data at any time, just send an
        email to{' '}
        <a href="mailto:data-protection.br@basf.com">
          data-protection.br@basf.com
        </a>
        requesting the revocation of your consent to the email address of the
        Data Officer, informed at the end of this Policy Please note that this
        revocation of consent may impact the availability of certain services
        and programs, as well as your access to information about the BASF,
        which are shared via digital channels such as marketing emails sent
        based on your interests.
      </p>
      <br />
      <p>
        Even after termination of the contractual relationship, we may handle
        some of your personal data to exercise our rights guaranteed by law,
        including as evidence in judicial, administrative or arbitrations,
        mainly those related to the regularization of claims involving you
        and/or third parties.
      </p>

      <h2>Data Retention</h2>
      <p>
        We store personal data for as long as needed to perform a service that
        you have requested or to fulfill the purposes for which you have given
        your permission, provided that there are no legal requirements to the
        contrary, for example in the case of retention periods required by trade
        or tax regulations.
      </p>

      <h2>Security</h2>
      <p>
        BASF has technical and organizational security measures in place to
        prevent the information you have provided from being intentionally or
        unintentionally manipulated, lost, destroyed or accessed by unauthorized
        persons. When personal data is being collected and processed,
        information will be transferred in encrypted form so as to prevent
        misuse of the data by third parties. Our security measures are
        continuously reviewed and revised in accordance with appropriate
        technology.
      </p>
      <br />
      <p>
        Although BASF uses its best efforts to preserve your privacy and protect
        your personal data, no information transmission is ever completely
        secure, so BASF cannot fully guarantee that all information it receives
        and/or sends will not be subject to unauthorized access by methods
        designed to obtain unauthorized information, such as technical failures,
        viruses, or website database intrusions.
      </p>
      <br />
      <p>
        In any case, in the unlikely event of an incident of this nature, BASF
        ensures its best efforts to remedy the consequences of the event. BASF
        should not be rendered liable for any other website that may be accessed
        from ours, and there is no link between such addresses.
      </p>

      <h2>Right to obtain and correct information</h2>
      <p>
        You have the right to obtain information about all your personal data
        stored, as well as to receive, examine and, if necessary, change or
        delete them. To that, simply send an e-mail to the e-mail address of the
        Data Controller, which you will find at the end of this Policy. The
        deletion of your personal data will be performed unless we are required
        by law to store such information (as per item “Data Retention” above).
      </p>
      <br />
      <p>
        BASF shall make its best efforts to comply with requests from Users in
        the shortest possible time. In case of request for deletion, the minimum
        storage term for information on Internet applications users, determined
        by the Brazilian legislation, shall be respected, in addition to other
        applicable laws as the labor and tax legislation.
      </p>

      <h2>Cookies</h2>
      <p>
        Cookies are small text files shared between your web browser and our
        website, and which are stored in the browser of the viewer’s device for
        a website they have visited (web server, server). The cookie is either
        sent from the web server to the browser or generated in the browser by a
        script (JavaScript). The web server can read this cookie information
        directly from the server when the user visits this page again, or
        transfer the cookie information to the server via a website script.
        Cookies do not cause any damage to your device, contain no viruses,
        Trojans or other Malware.
      </p>
      <p>
        Information is stored in the cookie related to the specific device used.
        This does not mean, however, that we are directly informed about your
        identity The information is stored in the device-related cookie specific
        used. This does not mean, however, that we get direct knowledge of their
        identity.
      </p>
      <br />
      <p>
        In general, we use cookies to provide you with a better experience in
        all aspects when browsing our platform.
      </p>
      <p>We generally use the following cookies: </p>
      <ol>
        <li>
          <strong>Strictly necessary cookies</strong>
        </li>
        <p>
          These cookies are necessary to run the website. In general, they are
          set only in response to actions you take that amount to a request for
          services, such as setting your privacy preferences, logging in or
          completing forms. You can set your browser either to block or to
          notify you of these cookies. However, some areas of the website may
          not work properly if this cookie mode is blocked. We use these cookies
          on the legal basis of Legitimate Interest, provided in Article 7, item
          IX, of the LGPD.
        </p>
        <li>
          <strong>Performance Cookies</strong>
        </li>
        <p>
          These cookies allow us to count visits as well as analyze traffic so
          that we can measure and improve our website performance.
        </p>
        <p>
          They help us answer questions about which pages are most popular,
          which are least used, as well as the visitors’ preferences of access
          within the website. All information collected by these cookies is
          aggregated and therefore anonymous. If you do not allow these cookies,
          we cannot know when you have visited our site.
        </p>
        <p>
          The consent provided for in Article 7(I) of the LGPD is the legal
          ground for processing these cookies.
        </p>
        <p>
          You have the right to revoke your consent at any time, without
          affecting the legality of the consent-based processing performed prior
          to revocation. For that, change the settings in the Privacy Preference
          Center.
        </p>
        <li>
          <strong>Functional Cookies</strong>
        </li>
        <p>
          These cookies enable the website to deliver enhanced functionality and
          customization. They may be set by us or by third parties whose
          services we use on our web pages. If you do not allow these cookies,
          some or all of these services may not work properly.
        </p>
        <p>
          The consent provided for in Article 7(I) of the LGPD is the legal
          ground for processing these cookies.
        </p>
        <p>
          You have the right to revoke your consent at any time, without
          affecting the legality of the consent-based processing performed prior
          to revocation. For that, change the settings in the Privacy Preference
          Center.
        </p>
        <li>
          <strong>Cookies for marketing purposes</strong>
        </li>
        <p>
          These cookies can be set through our website. They may be used by our
          marketing partners to profile your interests, and show you relevant
          ads on other websites. If you do not allow these cookies, you will
          experience less targeted advertising.
        </p>
        <p>
          The consent provided for in Article 7(I) of the LGPD is the legal
          ground for processing these cookies.
        </p>
        <p>
          You have the right to revoke your consent at any time, without
          affecting the legality of the consent-based processing performed prior
          to revocation. For that, change the settings in the Privacy Preference
          Center.
        </p>
        <li>
          <strong>Cookie management, purposes and storage period</strong>
        </li>
        <p>
          We collect the following cookies, depending on your settings in the
          Privacy Preference Center.
        </p>
        <table>
          <tr>
            <th>Cookie Name</th>
            <th>Purpose</th>
            <th>Duration</th>
          </tr>
          <tr>
            <td>Cookie Layer</td>
            <td>
              This cookie stores the user’s agreement to accept the use of
              cookies.
            </td>
            <td>It is deleted as soon as you clear your browser’s cache.</td>
          </tr>
          <tr>
            <td>Disclaimer Cookie</td>
            <td>
              This cookie stores the user’s agreement to the disclaimer on web
              pages protected by disclaimers.
            </td>
            <td>It is deleted as soon as you clear your browser’s cache.</td>
          </tr>
          <tr>
            <td>Google Analytics Cookie</td>
            <td>
              With this cookie the web analytics tool called Google Analytics
              gathers anonymous information about how our website/app is used.
              The information collected helps us to continuously address the
              needs of our visitors. It stores information such as, for example,
              how many people visit our site/app, which websites they come from,
              and which pages they view.
            </td>
            <td>It automatically expires after 50 months.</td>
          </tr>
          <tr>
            <td>Google Ads Cookie</td>
            <td>
              This cookie stores information on navigability, such as the pages
              visited on the website/app originating from the Google search
              engine.
            </td>
            <td>
              Policy applies to Google Analytics (automatically expires after 50
              months).
            </td>
          </tr>
          <tr>
            <td>Marketing Cloud (Sales Force)</td>
            <td>
              This cookie stores personal data provided by users, to be used by
              BASF as per the “Data Collection and Processing” section of this
              Policy.
            </td>
            <td>Data may be deleted at any time upon request by the user.</td>
          </tr>
          <tr>
            <td>LinkedIn Cookie</td>
            <td>
              This cookie stores information about LinkedIn’s privacy and cookie
              policies, navigability, for advertising purposes in digital
              environment.
            </td>
            <td>
              According to the LinkedIn cookie and privacy policies,
              navigability, for the purpose of advertising in the digital
              environment. The user can disable the data storage function at any
              time.
            </td>
          </tr>
        </table>
        <p>
          You can enable and disable the collection of the described cookies,
          according to category, via the cookie preferences set in the Privacy
          Preference Center. Only strictly necessary cookies are enabled by
          default.
        </p>
        <p>
          If you also do not want the use of cookies of this nature, you have
          the option of rejecting cookies on your browser. We provide access to
          this function for all major browsers at the following links:
        </p>
        <ul>
          <li>
            <a href="https://support.google.com/chrome/answer/95647?hl=pt-BR">
              Google Chrome:
              https://support.google.com/chrome/answer/95647?hl=pt-BR
            </a>
            ;
          </li>
          <li>
            <a href="https://support.microsoft.com/pt-br/topic/excluir-e-gerenciar-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-11">
              Internet Explorer:
              https://support.microsoft.com/pt-br/topic/excluir-e-gerenciar-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-11
            </a>
            ;
          </li>
          <li>
            <a href="https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento">
              Firefox:
              https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento
            </a>
            ;
          </li>
          <li>
            <a href="http://safari.helpmax.net/ps/privacidade-e-seguranca/como-remover-cookies/">
              Safari:
              http://safari.helpmax.net/ps/privacidade-e-seguranca/como-remover-cookies/
            </a>
            .
          </li>
        </ul>
        <p>
          It is important to remember that some of these cookies are essential
          for navigation, so that the functionality of the website visited may
          be affected if they are deactivated or rejected.
        </p>
        <p>
          If you wish further information or solve any questions on how we
          collect and process your information through cookies, please contact
          us through the e-mail/link
          <a href="mailto:data-protection.br@basf.com">
            data-protection.br@basf.com
          </a>
        </p>
      </ol>

      <h2>Applicable Law and Forum</h2>
      <p>
        This Policy shall be interpreted in accordance with the laws, rules and
        regulations of Brazil, in the Portuguese language, especially in
        accordance with Law No. 13.709/2018 (General Data Protection Law). Any
        conflicts shall be settled in the Brazilian territory and according to
        the Brazilian legislation applicable and in force at the time.
      </p>

      <h2>Contact - Data Controller</h2>
      <p>
        The continuous development of Internet makes it necessary for us to
        adjust our data protection rules from time to time. We reserve the right
        to implement appropriate changes at any time. If you have any questions
        or suggestions, please contact the Data Protection Officer at BASF, who
        will be happy to help you. Our Data Protection Officer is:
      </p>
      <br />
      <h6>
        Andre de Oliveira
        <br />
        Data Protection Officer - Brazil
        <br />
        email:{' '}
        <a href="mailto:data-protection.br@basf.com">
          data-protection.br@basf.com
        </a>
      </h6>
    </div>
  );
};

export default En;
